import React from "react";
import PropTypes from "prop-types";
import { Box, Button, useMediaQuery } from "@mui/material";
import json2mq from "json2mq";
import { shortQueries } from "../queries";

const textStyle = {
  fontFamily: "'Open Sans', sans-serif",
};

export const MeasurItWelcome = (props) => {
  const short = useMediaQuery(json2mq(shortQueries));

  return (
    <div style={textStyle}>
      <h3>Estimate Your Lawn</h3>
      <img
        src={short ? "/measur.it-intro-small.png" : "/measur.it-intro.png"}
        alt="measureit-welcome"
        style={short ? { width: 225 } : { width: 300 }}
      />
      <p style={short ? { width: 225, fontSize: 14 } : {}}>
        <span style={{ fontWeight: "bold", color: "#1976d2" }}>Measur.it</span>{" "}
        is an easy way to measure online.
        <br />
        <br />
        If you can use a paint brush, you can measure your lawn.
      </p>
      <Box sx={{ textAlign: "right" }}>
        <Button
          color="primary"
          variant="contained"
          onClick={() => props.goTo(1)}
        >
          Continue
        </Button>
      </Box>
    </div>
  );
};

MeasurItWelcome.propTypes = {
  goTo: PropTypes.func.isRequired,
};
